<script>
import store from '@state/store'
import ButtonAction from '@components/button-action'
import Title from '@components/section-title'
import FeedbackWrapper from '@modules/global/components/feedback-wrapper/feedback-wrapper.vue'
import {
  formatNumber,
  getNumber,
  getUnique,
  possivelJSON,
  toMoney,
  toPercent,
  toTitleCase,
  getRandomColor,
} from '@utils/Format'
import { customSort } from '@utils/Sort'
import ModalPesquisaHistorico from '@modal/simulador-pesquisa-historico'
import ModalTrocar from '@modal/trocar-ativo'
import ModalAmpliarTabela from '@modal/simulador-ampliar-tabela'
import ModalRestricoes from '@modal/simulador-modal-restricoes'
import { GlobalBus } from '@services/bus'
import TabelaRetornoMensais from '@components/tabela-retornos-mensais'
import TabelaRentBenchmark from '@components/tabela-rent-benchmark'
import { aawzDate } from '@utils/dates/aawz-date'
import {
  BLACK_LIST_CALCULO_RENTABILIDADE,
  LINK_TUTORIALS,
  MODAL,
  RELOAD,
  simuladorRoutes,
} from '@constants/Text'
import { minhaCarteira, pdf, simulador } from '@constants/URL'
import con from '@services/connection'
import { funcaoIndisponivel } from '@utils/Whitelabel'
import { hasIncompleteAssets } from '@modules/consolidator/utils/HasIncompleteAssets/HasIncompleteAssets'
import LoadingStatus from '@components/loading-status'
import ShowLiquidez from '@components/show-liquidez-readonly'
import ShowComposition from '@components/show-composition'
import Vue from 'vue'
import Cores from '@constants/Color'
import { apiSettingsBenchmarks } from '@modules/settings/api/apiSettingsBenchmarks'
import { apiConsolidatorSimulatorResult } from '@modules/consolidator/api/apiConsolidatorSimulatorResult.js'
import SimulatorPortfolioTable from '@modules/portfolio-review/components/simulator-portfolio-table/simulator-portfolio-table.vue'
import SimulatorOperationsTable from '@modules/portfolio-review/components/simulator-operations-table/simulator-operations-table.vue'
import ModalPortfolioReviewEditNotes from '@modules/portfolio-review/modal/edit-notes/portfolio-review-edit-notes.vue'
import ConditionalTeleport from '@components/teleport/conditional-teleport.vue'

export default {
  page: {
    title: 'Análise de simulações',
    meta: [{ name: 'description', content: 'AnaliseSimulacoes' }],
  },
  components: {
    Title,
    ButtonAction,
    FeedbackWrapper,
    ModalPesquisaHistorico,
    ModalTrocar,
    TabelaRetornoMensais,
    LoadingStatus,
    TabelaRentBenchmark,
    ModalAmpliarTabela,
    ModalRestricoes,
    ShowLiquidez,
    ShowComposition,
    SimulatorPortfolioTable,
    SimulatorOperationsTable,
    ModalPortfolioReviewEditNotes,
    ConditionalTeleport,
  },
  props: {
    bus: {
      type: Object,
      default: null,
    },
    clienteModal: {
      type: Object,
      default: null,
    },
    hashSimulacaoModal: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      toTitleCase,
      benchmarks_selecionados: [],
      benchmarks_selecionados_grafico: [],
      benchmarks_line: {},
      busModal: new Vue(),
      SHOW_WORKSPACE: SHOW_WORKSPACE,
      isWhitelabel: WHITELABEL,
      loading: false,
      loads: {},
      loadingPDF: false,
      loadingCliente: false,
      simulando: false,
      simulationError: '',
      simulationErrorMessage:
        'Não foi possível gerar a carteira. Revise as restrições e simule novamente.',
      headerCarteiraSimples: [
        {
          text: 'Ativo',
          align: 'left',
          value: 'nome_ativo',
        },
        {
          text: 'P/L atual',
          value: 'aplicacao',
        },
        {
          text: '%',
          value: 'percent',
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
        },
      ],
      headerCarteiraSimulada: [
        {
          text: 'Ativo',
          align: 'left',
          value: 'nome_ativo',
        },
        {
          text: 'Referência Backtest',
          value: 'referencia',
          width: 190,
          class: 'no-wrap',
        },
        {
          text: 'P/L Fixado',
          value: 'pl_fixado',
        },
        {
          text: 'P/L Simulado',
          value: 'aplicacao',
          width: 150,
        },
        {
          text: '%',
          value: 'percent',
        },
        {
          text: 'Recomendação',
          value: 'recomendacao',
          width: 160,
          sortable: false,
        },
        {
          text: 'Setor',
          value: 'setor',
          width: 120,
        },
        {
          text: 'Comentário',
          value: 'comentario',
          width: 220,
        },
        {
          text: 'Tags',
          value: 'tags',
          width: 220,
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110,
        },
      ],
      headerCarteiraCompleta: [
        {
          text: 'Ativo',
          align: 'left',
          value: 'nome_ativo',
          width: 500,
        },
        {
          text: 'P/L Atual',
          value: 'pl_atual',
        },
        {
          text: 'Movimentação',
          value: 'movimentacao',
        },
        {
          text: 'P/L Simulado',
          value: 'pl_final',
        },
        {
          text: 'Recomendação',
          value: 'recomendacao',
          width: 160,
          sortable: false,
        },
        {
          text: 'Setor',
          value: 'setor',
          width: 120,
        },
        {
          text: 'Comentário',
          value: 'comentario',
        },
        {
          text: 'Tags',
          value: 'tags',
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110,
        },
      ],
      headerCarteiraOperacoes: [
        {
          text: 'Ativo',
          align: 'left',
          value: 'nome_ativo',
          width: 500,
        },
        {
          text: 'Operação',
          value: 'operacao',
        },
        {
          text: 'P/L movimentado',
          value: 'movimentacao',
        },
      ],
      lineChartSim: {
        labels: ['1', '2', '3', '4'],
        datasets: [
          {
            label: 'Backtest',
            fill: false,
            borderColor: this.$Color().primary,
            backgroundColor: this.$Color().primary,
            borderWidth: 5,
            data: [],
          },
          // {
          //   label: 'Benchmark',
          //   fill: false,
          //   stepped: true,
          //   borderWidth: 5,
          //   borderColor: '#2D212F',
          //   backgroundColor: '#2D212F',
          //   data: [],
          //   line: {
          //     borderDash: [0, 10],
          //     borderCapStyle: 'round',
          //   },
          // },
        ],
      },
      lineChartAtual: {
        labels: [],
        datasets: [],
      },
      lineOptions: {
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: (item, data) => {
              let label = data.datasets[item.datasetIndex].label || ''
              label += ': ' + toPercent(item.yLabel * 100)
              return label
            },
          },
        },
        hover: {
          mode: 'index',
          intersect: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontSize: 10,
                callback: (v, i, vs) => {
                  return toPercent(v * 100)
                },
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          point: {
            radius: 0,
            borderWidth: 0,
            style: 'star',
          },
          line: {
            borderWidth: 0,
          },
        },
        legend: {
          position: 'bottom',
        },
      },
      compAtual: {},
      compSim: {},
      restricoes_simulacao: {},
      simulacao: {
        nome_simulacao: 'Simulação',
        hash: '', // '285a34db-ade2-4803-995a-9d23c92e086e',
        id_cliente: 0, // 5993,
        load: 0,
        status: 'Iniciando...',
      },
      pl_atual: 0,
      pl_total: 0,
      operacoes: [],
      messages: [],
      ativos: [],
      backtest: {},
      estatisticas: {},
      estatisticaAtual: {},
      ativosAtuais: [],
      novosAtivos: [],
      evolucaoAtual: {},
      retorno_mensal: { 2020: {} },
      cenarios: [],
      cenario_portfolio: {},
      estatistica_portfolio: {
        ipca: {},
        rentabilidade_relativo: {},
        rentabilidade: { mes: '' },
      },
      historico_simulacoes: [],
      agrupar_tabelas: false,
      has_changes: false,
      liquidez: [],
      benchmark_graph_changed: false,
      // Modo do simulador: [classe, subclasse]
      modo: 'classe',
    }
  },
  computed: {
    moduleRoutes() {
      return simuladorRoutes()
    },
    alertMessages() {
      return (this.messages || [])
        .map((m) => (m || '').replaceAll(/(?:\s|<br\s*\/?>)+$/gi, '').trim())
        .filter(Boolean)
    },
    BENCHMARKS() {
      return this.$store.getters['settings/benchmarks']
    },
    clienteAtual() {
      return this.clienteModal || store.getters['user/currentClient'] || {}
    },
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    carregando() {
      return Object.values(this.loads).some((a) => {
        return a
      })
    },
    horizonteDiff() {
      try {
        if (
          this.backtest.portfolio &&
          this.backtest.portfolio.data.length > 0
        ) {
          const a = aawzDate(this.backtest.portfolio.data[0], 'DD/MM/YYYY')
          const b = aawzDate(
            this.backtest.portfolio.data[
              this.backtest.portfolio.data.length - 1
            ],
            'DD/MM/YYYY'
          )
          return b.diff(a.toDate(), 'months') + ' meses'
        }
      } catch (e) {
        console.error(e)
      }
      return ''
    },
    historico() {
      return this.historico_simulacoes
        .filter((s) => {
          return s.nome_simulacao != this.simulacao.nome_simulacao
        })
        .reverse()
    },
    Color() {
      return store.getters['parameters/colors'] || {}
    },
    Paleta() {
      return store.getters['parameters/paleta'] || {}
    },
    lineDataSimulacao() {
      if (this.backtest.portfolio) {
        const aux = { ...this.lineChartSim }
        aux.labels = this.backtest.portfolio['data']
        if (aux.datasets[0]) {
          aux.datasets[0].borderColor = this.Color.primary
          aux.datasets[0].backgroundColor = this.Color.primary
          aux.datasets[0].data = this.backtest.portfolio['rent']
          // aux.datasets[1].data =
          //   this.backtest.benchmark['rentabilidade_acumulada'] ||
          //   this.backtest.benchmark['rentabiliade_acumulada']
        }

        const benchs = []
        this.benchmarks_selecionados_grafico.forEach((key) => {
          benchs.push(this.benchmarks_line[key])
        })

        return { ...aux, datasets: [...aux.datasets, ...benchs] }
      } else {
        return this.lineChartSim
      }
    },
    compEstr() {
      const aux = {}
      let cont = 0
      Object.entries(this.compSim).forEach((a) => {
        aux[a[0]] = {
          name: a[0],
          color: this.Paleta[cont++],
          percent: (a[1] / this.pl_total) * 100, // a[1],
          atual: 0,
          value: a[1], // (a[1] / 100) * this.pl_total,
        }
      })
      Object.entries(this.compAtual).forEach((a) => {
        if (aux[a[0]]) {
          aux[a[0]].atual = (a[1] / this.pl_atual) * 100
        } else {
          aux[a[0]] = {
            name: a[0],
            color: this.Paleta[cont++],
            percent: 0,
            atual: (a[1] / this.pl_atual) * 100,
          }
        }
      })

      return aux
    },
    headerMenuActions() {
      return [{ key: 'tutorial', label: 'Tutorial', icon: 'video' }]
    },
    cardMenuActions() {
      const actions = [
        {
          key: 'simular-novamente',
          label: 'Simular novamente',
          icon: 'mdi-play-circle-outline',
        },
      ]
      if (this.simulacao.hash_code) {
        actions.push(
          {
            key: 'comparar',
            label: 'Comparar',
            icon: 'mdi-compare-horizontal',
          },
          {
            key: 'ver-restricoes',
            label: 'Ver restrições',
            icon: 'eye',
          }
        )
      }
      if (this.restricoes_simulacao.tipo_simulador) {
        actions.push({
          key: 'alterar-restricoes',
          label: 'Alterar restrições',
          icon: 'mdi-tune-variant',
        })
      }
      return actions
    },
  },
  created() {
    this.busModal.$on('search_simulacao', this.reload)
    this.busModal.$on('changed_asset', this.ativoTrocado)

    if (this.hashSimulacaoModal && this.clienteModal) {
      // Caso esteja apresentando uma simulação por modal.
      this.simulacao.hash_code = this.hashSimulacaoModal
      this.simulacao.id_cliente = this.clienteModal.id
      this.loadSimulation()
    } else {
      if (
        this.$route.params.hash_code &&
        this.$route.params.hash_code != 'undefined'
      ) {
        // Caso esteja abrindo uma simulação por hash_code na rota (front param).
        this.simulacao.hash_code = this.$route.params.hash_code
        this.simulacao.id_cliente = this.$route.params.id_cliente
        this.simulacao.nome_simulacao =
          this.$route.params.nome_simulacao || 'Simulação'
        this.loadSimulation()
      }
      if (this.$route.params.simulacao) {
        // Caso esteja abrindo a simulação recebendo o objeto inteiro (front param).
        this.simulacao = this.$route.params.simulacao
        this.loadSimulation()
      }
      if (!this.$route.params.hash_code && !this.$route.params.simulacao) {
        if (this.$route.query && this.$route.query.hash_code) {
          this.simulacao.hash_code = this.$route.query.hash_code
          this.simulacao.id_cliente = this.$route.query.id_cliente
          this.simulacao.nome_simulacao =
            this.$route.query.nome_simulacao || 'Simulação'
          this._syncCurrentClientFromQuery(this.$route.query.id_cliente)
          this.loadSimulation()
        } else {
          // Se não recebeu o objeto da simulação, nem o hash_code, carrega a última aberta.
          this._getLastSimulation()
        }
      }
    }

    GlobalBus.$on('changeClient', this._getLastSimulation)
    GlobalBus.$on(MODAL.OPEN_SEND_COMPONENT, this.openSendComponent)

    this.$store.dispatch('subclasse/carregar')
  },
  beforeDestroy() {
    GlobalBus.$off('changeClient', this._getLastSimulation)
    GlobalBus.$off(MODAL.OPEN_SEND_COMPONENT, this.openSendComponent)
  },
  methods: {
    clear(full) {
      this.compAtual = {}
      this.compSim = {}
      this.restricoes_simulacao = {}
      this.simulationError = ''
      this.pl_atual = 0
      this.pl_total = 0
      this.operacoes = []
      this.messages = []
      this.ativos = []
      this.backtest = {}
      this.estatisticas = {}
      this.estatisticaAtual = {}
      this.ativosAtuais = []
      this.novosAtivos = []
      this.evolucaoAtual = {}
      this.has_changes = false
      this.liquidez = []

      this.benchmark_graph_changed = false

      if (full) {
        this.simulacao = {
          nome_simulacao: 'Simulação',
          hash: '', // '285a34db-ade2-4803-995a-9d23c92e086e',
          id_cliente: 0, // 5993,
          load: 0,
          status: 'Iniciando...',
        }
        this.retorno_mensal = { 2020: {} }
        this.cenarios = []
        this.cenario_portfolio = {}
        this.historico_simulacoes = []
        this.estatistica_portfolio = {
          ipca: {},
          rentabilidade_relativo: {},
          rentabilidade: { mes: '' },
        }
        this.lineChartAtual = {
          labels: [],
          datasets: [],
        }
      }
    },
    normalizeTags(rawTags) {
      if (Array.isArray(rawTags)) {
        return rawTags
      }

      if (!rawTags) {
        return []
      }

      if (typeof rawTags === 'string') {
        const trimmed = rawTags.trim()

        if (!trimmed) {
          return []
        }

        const parsed = possivelJSON(trimmed)
        if (Array.isArray(parsed)) {
          return parsed
        }

        if (trimmed[0] === '[' && trimmed[trimmed.length - 1] === ']') {
          const inner = trimmed.slice(1, -1)
          const parts = inner.split(',')
          const tags = parts
            .map((tag) => tag.replace(/^['"\s]+|['"\s]+$/g, ''))
            .filter((tag) => tag)

          if (tags.length) {
            return tags
          }
        }

        return [trimmed]
      }

      return []
    },
    openSendComponent() {
      GlobalBus.$emit(
        MODAL.WORKSPACE_SEND_COMPONENT,
        {
          page: this.$route.name,
          data: {
            id_cliente: this.$currentClient().id,
            hash_simulacao: this.simulacao.hash_code,
          },
        },
        this.$currentClient()
      )
    },
    abrirModal() {
      setTimeout(() => {
        this.$refs.rentabilidade2.$forceUpdate()
      }, 300)
    },
    getDistanceDate(d) {
      return aawzDate(d, 'DD/MM/YYYY').formatRelative()
    },
    toPercent(d) {
      return toPercent(d)
    },
    formatNumber(d) {
      return formatNumber(d)
    },
    toMoney(d) {
      return toMoney(d)
    },
    async loadSimulation() {
      this.clear()
      const sim = this.simulacao.hash_code
      const id = this.simulacao.id_cliente_app || this.simulacao.id_cliente
      if (sim) {
        this.loading = true
      }
      await this._getRestricoes(sim)
      this._loadData(sim, id)
      // TODO: Verificar dados, parece nao estar usando para nada.
      // this._loadBacktest(sim, id)
      // this.setCarteira(id)
      this.setEvolucao(id)
      this.setEstatisticas(id, sim)
      this._checkMessages(sim)
      this._getName()

      this._saveLastSimulation()
    },
    // Ao abrir a simulação numa aba nova (via query), o app restaura o último
    // cliente do localStorage — divergente da simulação aberta. Sincroniza o
    // currentClient pelo id_cliente da query (lookup em allClients), igual ao
    // simulador-detalhes. NÃO emite 'changeClient' (dispararia _getLastSimulation
    // e sobrescreveria a simulação da query).
    _syncCurrentClientFromQuery(idCliente) {
      if (!idCliente) return
      const client = store.getters['user/allClients'].find(
        (c) => String(c.id) === String(idCliente)
      )
      if (client) store.dispatch('user/addSearchClient', client)
    },
    _getLastSimulation() {
      const sim = window.localStorage.getItem(
        `19d489c-${this.usuarioAtual.id_interno}-${this.clienteAtual.id}698dc`
      )
      if (sim && sim != 'undefined') {
        this.simulacao.hash_code = sim
        this.simulacao.id_cliente = this.clienteAtual.id
        this.loadSimulation()
      } else {
        this.clear(true)
      }
    },
    _saveLastSimulation() {
      if (
        this.usuarioAtual.id_interno &&
        this.clienteAtual.id &&
        this.simulacao.hash_code
      ) {
        window.localStorage.setItem(
          `19d489c-${this.usuarioAtual.id_interno}-${this.clienteAtual.id}698dc`,
          this.simulacao.hash_code
        )
      }
    },
    async setEstatisticas(id_cliente, hash) {
      if (!hash) {
        return
      }
      this.$set(this.loads, 'estatisticas', true)
      const partes = [
        'monthly_return',
        'portfolio_statistics',
        'portfolio_scenarios',
        'graph_liquidity',
        'simulation_backtest',
      ]
      const r = await con.get(
        `${
          simulador.analise
        }${id_cliente}?simulation_hash_code=${hash}&report_parts=${partes.join(
          ','
        )}&group_by=${this.modo}`
      )
      if (r.status === 200) {
        this.retorno_mensal = r.value.monthly_return
        this.cenarios = r.value.portfolio_scenarios
        this.cenario_portfolio = r.value.portfolio_scenarios
          ? r.value.portfolio_scenarios.find((c) => {
              return c.classe == 'portfolio'
            }) || {}
          : {}
        this.estatistica_portfolio = r.value.portfolio_statistics

        this.liquidez = r.value.graph_liquidity
        this.formatGraficoPortfolio({
          benchmark: r.value.simulation_backtest['benchmarks-returns'],
        })

        this.backtest = {
          portfolio: {
            data: r.value.simulation_backtest.index,
            rent: r.value.simulation_backtest['portfolio-simulation'],
            start: r.value.simulation_backtest.begin,
            end: r.value.simulation_backtest.end,
          },
        }
      } else {
        this.retorno_mensal = { 2020: {} }
        this.cenarios = []
        this.cenario_portfolio = {}
        this.estatistica_portfolio = {
          ipca: {},
          rentabilidade_relativo: {},
          rentabilidade: { mes: '' },
        }
        this.liquidez = []
        this.benchmarks_line = []
        this.backtest = {}
      }
      this.$set(this.loads, 'estatisticas', false)
      this.loading = false
    },
    async formatGraficoPortfolio(val) {
      await apiSettingsBenchmarks.carregar()
      const graphBenchmark = val.benchmark || {}
      const benchs = this.$store.getters['settings/benchmarks']
      const cdi = benchs.find((b) => b.nome == 'CDI')
      if (cdi) {
        this.benchmarks_selecionados_grafico.push(cdi.id)
      }

      this.benchmarks_line = benchs.reduce((all, bench) => {
        const color = Cores.BENCHMARKS_COLORS[bench.nome] || getRandomColor()
        all[bench.id] = {
          label: bench.nome,
          data: graphBenchmark[bench.id] || [],
          borderColor: color,
          backgroundColor: color,
          fill: false,
          stepped: true,
          pointRadius: 0,
          borderWidth: 3,
          line: {
            borderDash: [0, 10],
            borderCapStyle: 'round',
          },
        }
        all[bench.nome] = all[bench.id]
        return all
      }, {})
    },
    async _getRestricoes(sim) {
      if (sim) {
        this.$set(this.loads, 'restricoes', true)
        const r = await con.get(
          simulador.manage + sim + '?attributes=restricoes_simulacao'
        )
        if (r.status === 200) {
          this.restricoes_simulacao = possivelJSON(r.value.restricoes_simulacao)
          this.modo = this.restricoes_simulacao.modo_simulador || 'classe'
        }
        this.$nextTick(() => {
          this.$set(this.loads, 'restricoes', false)
        })
      }
    },
    async _checkMessages(sim) {
      if (!sim) {
        return
      }
      const r = await con.get(
        simulador.manage +
          this.simulacao.hash_code +
          '?attributes=resultado_simulacao'
      )
      if (r.status === 200) {
        this.messages = []
        if (r.value.resultado_simulacao && r.value.resultado_simulacao.alerta) {
          this.messages = [
            ...this.messages,
            ...r.value.resultado_simulacao.mensagem_alerta,
          ]
        }
        if (r.value.resultado_simulacao && r.value.resultado_simulacao.caixa) {
          this.messages = [
            ...this.messages,
            ...r.value.resultado_simulacao.caixa_message,
          ]
        }
      } else {
        this.messages = []
      }
    },
    async _getName() {
      if (!this.simulacao.hash_code) {
        return
      }
      const r = await con.get(
        simulador.manage +
          this.simulacao.hash_code +
          '?attributes=nome_simulacao,simulacao_salva' // expire_date
      )
      if (r.status === 200) {
        this.simulacao.nome_simulacao = r.value.nome_simulacao
        this.simulacao.simulacao_salva = r.value.simulacao_salva
      } else {
        this.simulacao.nome_simulacao = 'Simulação'
        this.simulacao.simulacao_salva = false
        this.simulacao.expire_date = ''
      }
    },
    async _loadData(sim, id) {
      if (!sim || !id) {
        return
      }

      this.$set(this.loads, 'data', true)

      const r = await apiConsolidatorSimulatorResult.loadResult({
        clientId: id,
        simulationHash: sim,
        forceUpdate: true,
      })

      if (r.status === 200) {
        if (r.value.simulation_status === 200) {
          this.estatisticas = r.value.statistics
          this.pl_total = r.value.statistics.pl
          this.operacoes = r.value.operations.map((item) => {
            if (!item.subclasse) {
              item.subclasse = item.classe
            }

            item.comentario =
              typeof item.comentario === 'string' ? item.comentario : ''

            item.tags = this.normalizeTags(item.tags)

            return item
          })
          this.ativos = (r.value.assets || []).map((a) => {
            a.comentario = typeof a.comentario === 'string' ? a.comentario : ''
            a.tags = this.normalizeTags(a.tags)
            return a
          })
          this._enrichOperationsFromAssets()
          const aux = {}
          if (r.value.assets) {
            r.value.assets.forEach((a) => {
              aux[a[this.modo]] = (aux[a[this.modo]] || 0) + a['Aplicação']
            })
          }
          this.compSim = aux
        } else {
          this.simulationError = this.simulationErrorMessage
        }
      } else {
        this.estatisticas = {}
        this.pl_total = 0
        this.operacoes = []
        this.ativos = []
        this.compSim = {}
      }

      this.$set(this.loads, 'data', false)
    },
    _enrichOperationsFromAssets() {
      const assetMap = {}
      this.ativos.forEach(function (a) {
        assetMap[a.nome_ativo] = a
      })
      this.operacoes = this.operacoes.map(function (op) {
        const asset = assetMap[op.nome_ativo]
        if (!asset) return op
        return Object.assign({}, op, {
          recomendacao: op.recomendacao || asset.recomendacao || '',
          setor: op.setor || asset.setor || '',
          comentario: op.comentario || asset.comentario || '',
          tags:
            op.tags && op.tags.length > 0 ? op.tags : asset.tags || [],
        })
      })
    },
    updateLocalNotes({ nomeAtivo, comentario, tags, recomendacao, setor }) {
      const applyUpdate = (list) =>
        Array.isArray(list)
          ? list.map((item) => {
              if (item.nome_ativo !== nomeAtivo) {
                return item
              }

              const updated = {
                ...item,
                comentario: comentario || '',
                tags: Array.isArray(tags) ? [...tags] : [],
              }

              if (recomendacao !== undefined) {
                updated.recomendacao = recomendacao
              }

              if (setor !== undefined) {
                updated.setor = setor
              }

              return updated
            })
          : list

      this.ativos = applyUpdate(this.ativos)
      this.operacoes = applyUpdate(this.operacoes)
    },
    async handleSaveNotes({ asset, comentario, setor, recomendacao, tags }) {
      if (!asset) {
        return
      }

      const clientId =
        this.simulacao.id_cliente_app || this.simulacao.id_cliente

      const cleanTags = Array.isArray(tags)
        ? tags
            .map((tag) => (tag == null ? '' : String(tag).trim()))
            .filter((tag) => tag)
        : []

      const payload = {
        clientId,
        simulationHash: this.simulacao.hash_code,
        nomeAtivo: asset.nome_ativo,
        comentario: comentario || '',
        tags: cleanTags,
        setor: setor !== undefined ? setor : undefined,
        recomendacao: recomendacao !== undefined ? recomendacao : undefined,
      }

      const r = await apiConsolidatorSimulatorResult.updateSuggestedAsset(
        payload
      )

      if (r && r.status === 200) {
        this.updateLocalNotes({
          nomeAtivo: asset.nome_ativo,
          comentario: comentario || '',
          tags: cleanTags,
          setor: setor !== undefined ? setor : undefined,
          recomendacao: recomendacao !== undefined ? recomendacao : undefined,
        })

        this.$showSnack({
          text: 'Dados do ativo atualizados com sucesso.',
          button: true,
        })
      } else {
        this.$showSnack({
          text:
            (r && r.message) ||
            'Não foi possível atualizar os dados do ativo.',
          button: true,
        })
      }
    },
    async _loadBacktest(sim, id) {
      return
      if (!sim || !id) {
      }
      this.$set(this.loads, 'backtest', true)
      const data = {
        id_cliente: id,
        simulation_hash_code: sim,
      }
      const r = await con.post(simulador.sim_backtest, data)
      if (r.status === 200) {
        this.backtest = r.value
      } else {
        this.backtest = {}
      }
      this.$set(this.loads, 'backtest', false)
    },
    async _loadOperacoes(sim, id) {
      if (!sim || !id) {
        return
      }
      const data = {
        id_cliente: id,
        simulation_hash_code: sim,
      }
      const r = await con.post(simulador.sim_operacoes, data)
      if (r.status === 200) {
        this.operacoes = r.value
      } else {
        this.operacoes = []
      }
    },
    async _loadAtivos(sim, id) {
      if (!sim || !id) {
        return
      }
      const data = {
        id_cliente: id,
        simulation_hash_code: sim,
      }
      const r = await con.post(simulador.sim_ativos, data)
      if (r.status === 200) {
        this.ativos = r.value || []
      } else {
        this.ativos = []
      }
    },
    async setEvolucao(id) {
      if (!id) {
        return
      }
      this.$set(this.loads, 'evolucao', true)
      const data = {
        id_cliente: id,
      }
      let r = await con.post(minhaCarteira.rentabilidade, data)
      if (r.status === 200) {
        this.estatisticaAtual = r.value.dados.find((r) => {
          return r.legend === 'Todos'
        }).summary
        this.lineChartAtual = {
          labels: r.value.data_competencia || [],
          datasets: [
            {
              label: 'Consolidado',
              fill: false,
              borderColor: this.Color.primary,
              backgroundColor: this.Color.primary,
              borderWidth: 5,
              data:
                r.value.dados.find((r) => {
                  return r.legend === 'Todos'
                }).values || [],
            },
            {
              label: 'Benchmark',
              fill: false,
              stepped: true,
              borderWidth: 5,
              borderColor: '#2D212F',
              backgroundColor: '#2D212F',
              data: r.value.benchmark.CDI || [],
              line: {
                borderDash: [0, 10],
                borderCapStyle: 'round',
              },
            },
          ],
        }
      } else {
        this.lineChartAtual = {
          labels: [],
          datasets: [],
        }
        this.estatisticaAtual = {}
      }
      this.$set(this.loads, 'evolucao', false)
    },
    async setCarteira(id) {
      if (!id) {
        return
      }
      this.$set(this.loads, 'carteira', true)
      const data = {
        id_cliente: id,
      }
      let r = await con.post(minhaCarteira.posicao, data)
      if (Object.keys(r).length) {
        const aux = []
        Object.keys(r).forEach((v) => {
          this.pl_atual += getNumber(r[v]['Aplicação'])
          aux.push(JSON.parse(r[v].ativos))
        })
        const comp = {}
        this.ativosAtuais = aux.flat().map((a) => {
          comp[a['CI']] = (comp[a['CI']] || 0) + a['Aplicação']
          return {
            Aplicação: a['Aplicação'],
            aplicacao: a['Aplicação_f'],
            classe: a['CI'],
            id_ativo: a.id,
            nome_ativo: a['Ativo + Taxa'],
            percent: a.final_formatado,
          }
        })
        this.compAtual = comp
      } else {
        this.ativosAtuais = []
        this.compAtual = {}
      }
      this.$set(this.loads, 'carteira', false)
      this.setIncompleteAssets(r)
    },
    setIncompleteAssets(r) {
      if (!this.usuarioAtual.IS_CLIENTE) {
        const has_incomplete = hasIncompleteAssets(
          r,
          BLACK_LIST_CALCULO_RENTABILIDADE
        )

        this.$store.dispatch('user/setClientInfo', {
          has_incompletes_assets: has_incomplete,
        })
      }

      this.$store.dispatch('user/checkIncompleteAsset')
    },
    entendaMaisEstatistica() {
      this.$showModal({
        title: 'Estatística',
        subtitle: 'Carteira simulada',
        text: `As estatísticas da simulação são realizadas considerando as boas práticas de mercado e gestão de portfólio. Utilizamos lógicas de precificação considerando a curva DI para renda fixa e o desvio padrão dos retornos para fundos de investimentos.
\n\n
\n
No gráfico você consegue verificar a rentabilidade acumulada, dia-a-dia, e na tabela logo abaixo você tem as estatísticas anualizadas dessa carteira.`,
        buttons: [
          {
            text: 'Ok',
            action: null,
            class: { primary: true },
          },
        ],
      })
    },
    sumPL(items, attr = 'Aplicação') {
      return toMoney(
        items.reduce((a, b) => {
          return a + getNumber(b[attr])
        }, 0)
      )
    },
    sumPercent(items) {
      return toPercent(
        items.reduce((a, b) => {
          return a + getNumber(b.percent)
        }, 0)
      )
    },
    openSearchHistory() {
      GlobalBus.$emit(MODAL.SIMULATOR_SEARCH_HISTORY, true)
    },
    openRestricoes() {
      GlobalBus.$emit(MODAL.VER_RESTRICOES, {
        ...this.simulacao,
        modo_simulador: this.modo,
      })
    },
    onHeaderAction(item) {
      if (item && item.key === 'tutorial') {
        this.showVideos()
      }
    },
    onCardAction(item) {
      const key = item && item.key
      if (key === 'simular-novamente') {
        this.simulateAgain()
      } else if (key === 'comparar') {
        this.$router.push({ name: 'simulador.comparativo' })
      } else if (key === 'ver-restricoes') {
        this.openRestricoes()
      } else if (key === 'alterar-restricoes') {
        this.toRestricoes()
      }
    },
    openEditNome() {
      const span = this.$refs.nomeSpan
      if (span && typeof span.click === 'function') {
        span.click()
      }
    },
    showVideos() {
      const item = LINK_TUTORIALS[this.$route.name]
      if (!item || !item.url) {
        this.$showSnack({
          text: 'Tutorial indisponível',
          button: true,
        })
        return
      }
      GlobalBus.$emit(MODAL.SHOW_VIDEOS, { list: [item] })
    },
    reload(simulacao) {
      if (this.loading || this.carregando) {
        return
      }
      this.loading = true
      if (simulacao) {
        this.simulacao = simulacao
        this.historico_simulacoes = [
          ...new Set([...this.historico_simulacoes, simulacao]),
        ]
        this.loadSimulation()
      }
    },
    async salvarNomeSimulacao() {
      if (!this.simulacao.hash_code) {
        this.$showSnack({
          text: 'Nenhuma simulação selecionada',
          button: true,
        })
      }
      const data = {
        id_cliente_app: this.simulacao.id_cliente_app,
        dados: JSON.stringify({
          nome_simulacao: this.simulacao.nome_simulacao,
          simulacao_salva: true,
        }),
      }
      const r = await con.put(simulador.manage + this.simulacao.hash_code, data)

      if (r.status === 200) {
        GlobalBus.$emit(RELOAD.SIM_RUNNING)
      }

      this.$showSnack({
        text: r.message,
        button: true,
      })
    },
    async toPermanent() {
      if (this.simulacao.simulacao_salva) {
        return
      }
      const data = {
        id_cliente_app: this.simulacao.id_cliente_app,
        dados: JSON.stringify({
          simulacao_salva: true,
        }),
      }
      const r = await con.put(simulador.manage + this.simulacao.hash_code, data)
      if (r.status === 200) {
        this.loadSimulation()
      }
      this.$showSnack({
        text: r.message,
        button: true,
      })
    },
    async simulateAgain() {
      this.simulationError = ''
      const r = await con.get(
        simulador.manage +
          this.simulacao.hash_code +
          '?attributes=restricoes_simulacao,id_cliente_app'
      )

      // Validação: verificar se a resposta da API é válida
      if (!r || r.status !== 200 || !r.value) {
        this.$showSnack({
          text: 'Não foi possível carregar os dados da simulação.',
          button: true,
        })
        return
      }

      // Inicializar restr como objeto vazio se não existir
      const restr = r.value.restricoes_simulacao || {}

      if (restr.ativos_fixos) {
        let ativos = possivelJSON(restr.ativos_fixos)
        ativos = getUnique([...ativos, ...this.novosAtivos], 'nome_ativo')
        restr.ativos_fixos = ativos.map((a) => {
          a.pl = getNumber(a.pl)
          return a
        })
      } else {
        restr.ativos_fixos = this.novosAtivos
      }

      if (restr.ativo_fixos) {
        delete restr['ativo_fixos']
      }

      const data = {
        id_cliente_app: r.value.id_cliente_app,
        id_cliente_web: this.clienteAtual.id_cadastro_cliente || null,
        simulacao: JSON.stringify(restr),
      }
      this.simulacao.id_cliente_app = r.value.id_cliente_app
      this.enviarSimular(data)
    },
    moreInfo(ativos, opts) {
      GlobalBus.$emit(MODAL.SIMULATOR_MORE_INFO, ativos, opts)
    },
    customSort(a, b, c) {
      const dict = {
        texts: ['nome_ativo', 'referencia'],
        numbers: [
          'pl_final',
          'movimentacao',
          'pl_atual',
          'percent',
          'aplicacao',
        ],
        dates: [],
      }
      return customSort(a, b, c, dict)
    },
    async enviarSimular(data) {
      if (!this.$currentClient().name) {
        this.$showSnack({
          text: 'Selecione um cliente para simular',
          button: true,
        })
        return
      }

      const r = await con.post(simulador.run, data)
      this.simulando = true
      this.simulacao = {
        ...this.simulacao,
        hash_code: r.value.simulation_hash_code,
        status: 'Enviando requisição',
        load: 0,
      }
      if (r.status === 200) {
        store.dispatch('simulador/addRunning', {
          ...this.simulacao,
          hash_code: r.value.simulation_hash_code,
          status_simulacao: '100',
          data_simulacao: aawzDate().format('DD/MM/YYYY HH:mm'),
          id_cliente: data.id_cliente_web,
          id_cliente_app: data.id_cliente_app,
          id_profissional: this.$currentUser().id_interno,
          nome_cliente: this.clienteAtual.name || '',
        })
      } else {
        this.$showSnack({
          text: r.message,
          button: true,
        })
      }
      setTimeout(() => {
        this.checkStatusSimulation(r.value.simulation_hash_code)
      }, 10000)
    },
    async checkStatusSimulation(sim) {
      const data = {
        id_cliente: this.clienteAtual.id,
        id_cliente_app: this.clienteAtual.id,
        id_cliente_web: this.clienteAtual.id_cadastro_cliente || null,
        simulation_hash_code: sim || this.simulacao.hash_code,
      }
      const r = await con.post(simulador.status, data)
      if (r.value && r.value.step > 0) {
        const progress = (r.value.step / r.value.n_steps) * 100
        this.simulacao = {
          ...this.simulacao,
          hash_code: r.value.hash_code,
          status: r.value.details,
          load:
            progress > this.simulacao.load
              ? progress + 2
              : this.simulacao.load + 2,
        }
        store.dispatch('simulador/updateRunning', {
          ...this.simulation,
          status_simulacao: r.value.status === 'running' ? 100 : 200,
        })
        setTimeout(() => {
          this.checkStatusSimulation(sim)
        }, 6000)
      } else {
        if (r.status === 200) {
          this.simulacao.id_cliente = this.clienteAtual.id
          this.simulacao.status = 'Enviando requisição'
          this.simulacao.load = 0
          this.simulando = false
          this.reload(this.simulacao)
          store.dispatch('simulador/updateRunning', {
            ...this.simulation,
            load: 1,
            status_simulacao: r.value.status === 'running' ? 100 : 200,
          })
        } else {
          this.simulationError = this.simulationErrorMessage
          store.dispatch('simulador/updateRunning', {
            ...this.simulation,
            load: 1,
            status_simulacao: r.status,
          })
          this.simulando = false
        }
      }
    },
    async toRestricoes() {
      if (!this.restricoes_simulacao.ativos_fixos) {
        this.restricoes_simulacao.ativos_fixos = []
      }
      this.restricoes_simulacao.ativos_fixos = [
        ...this.restricoes_simulacao.ativos_fixos,
        ...this.novosAtivos,
      ]
      this.$router.push({
        name: `simulador.${this.restricoes_simulacao.tipo_simulador}`,
        params: {
          restricoes: this.restricoes_simulacao,
        },
      })
    },
    trocarAtivo(asset) {
      const old = this.novosAtivos.find((a) => {
        return asset.nome_ativo === a.nome_ativo
      })
      if (old) {
        this.$showSnack({
          text: 'Não é possível trocar este ativo.',
          button: true,
        })
        return
      }
      this.busModal.$emit(MODAL.CHANGE_ASSET, asset)
    },
    ativoTrocado(asset) {
      const old = this.novosAtivos.find((a) => {
        return a.nome_ativo === asset.antigo.nome_ativo
      })
      const ativo = this.ativos.find((a) => {
        return a.nome_ativo === asset.antigo.nome_ativo
      })

      // Validação: ativo deve existir na lista de ativos da simulação
      if (!ativo) {
        this.$showSnack({
          text: 'Ativo não encontrado na simulação atual.',
          button: true,
        })
        return
      }

      const aplicacaoAtual = getNumber(ativo['Aplicação']) || getNumber(ativo.aplicacao) || 0

      if (old) {
        old.pl = aplicacaoAtual - getNumber(asset.novo.pl)
        old.percent = '0,00%'
        delete old['Aplicação']
      } else {
        const aux = {
          ...asset.antigo,
          pl: aplicacaoAtual - getNumber(asset.novo.pl),
        }
        delete aux['Aplicação']
        this.novosAtivos.push(aux)
      }
      const novo = {
        pl: getNumber(asset.novo.pl),
        nome_ativo: asset.novo.nome_ativo,
        classe: asset.novo.classe,
        tipo: asset.novo.tipo,
      }
      this.novosAtivos.push(novo)
      this.has_changes = true
      this.$showSnack({
        text: `Ativos trocados com sucesso`,
        button: true,
      })
    },
    bloquearAtivo(asset) {
      if (this.checkAssetInSimulation(asset)) {
        this.$showSnack({
          text: 'Não é possível bloquear este ativo.',
          button: true,
        })
      } else {
        delete asset['Aplicação']
        this.addAtivo({ ...asset, pl: 0 })
        this.has_changes = true
        this.$showSnack({
          text: `${asset.nome_ativo} bloqueado com sucesso`,
          button: true,
        })
      }
    },
    fixarAtivo(asset) {
      if (this.checkAssetInSimulation(asset)) {
        this.removerAtivo(asset)
        // this.$showSnack({
        //   text: 'Não é possível fixar este ativo.',
        //   button: true,
        // })
      } else {
        if (!asset.pl) {
          asset.pl =
            getNumber(asset.pl_atual) ||
            getNumber(asset.aplicacao) ||
            getNumber(asset['Aplicação'])
        }
        delete asset['Aplicação']
        this.addAtivo(asset)
        this.has_changes = true
        this.$showSnack({
          text: `${asset.nome_ativo} fixado com sucesso`,
          button: true,
        })
      }
    },
    addAtivo(ativo) {
      /**
       * id_ativo [na base]
       * classe
       * id_ativo_atual [null se não houver]
       * nome_ativo
       * pl
       * referencia
       *
       * modo
       * percentual
       */
      const index = this.novosAtivos.findIndex((a) => {
        return a.nome_ativo === ativo.nome_ativo
      })
      if (index >= 0) {
        console.warn('Adicionando ativo existente')
        this.$set(this.novosAtivos, index, ativo)
      } else {
        this.novosAtivos.push(ativo)
      }
      return index
    },
    /**
     * Remover ativo da lista de ativos novos.
     * @param {String} nome_ativo
     * @param {Integer} id_ativo
     * @param {String} acao
     */
    removerAtivo({ nome_ativo }, acao = 'fixado') {
      if (nome_ativo) {
        const oldLength = this.novosAtivos.length
        const novosAtivos = this.novosAtivos.filter((asset) => {
          return asset.nome_ativo !== nome_ativo
        })
        if (oldLength - novosAtivos.length <= 1) {
          this.novosAtivos = novosAtivos
          this.$showSnack({
            text: `${nome_ativo} não está mais ${acao || 'na simulação'}`,
            button: true,
          })
        }
      }
    },
    /**
     * Verifica se o ativo ja foi adicionado na nova simulacao
     * @param {Object} asset Ativo para verificar
     * @returns {Boolean} Ja existe?
     */
    checkAssetInSimulation(asset) {
      const existente = this.novosAtivos.find((a) => {
        return asset.nome_ativo === a.nome_ativo
      })
      return existente
    },
    async checkStatusPDF(hash, id_cliente, send_client = false) {
      const r = await con.get(pdf.simulacao.get + `${id_cliente}/${hash}`)
      if (r.status === 200 && r.step == -1) {
        if (send_client) {
          this.enviarParaCliente(hash)
          this.loadingCliente = false
        } else {
          this.baixarPDF(hash, id_cliente)
          this.loadingPDF = false
        }
      } else if (r.status === 200) {
        setTimeout(() => {
          this.checkStatusPDF(hash, id_cliente, send_client)
        }, 3000)
      } else {
        this.loadingPDF = false
        this.$showSnack({
          text: r.message,
          button: true,
        })
      }
    },
    baixarPDF(hash, id_cliente) {
      window.location.href =
        window.location.origin +
        pdf.simulacao.get +
        `${id_cliente}/${hash}?download=true`
    },
    /**
     * Gerar PDF e "enviar" para o cliente.
     */
    async sendClient() {
      if (!this.isWhitelabel) {
        funcaoIndisponivel(this)
        return
      }

      this.openSelectModelPDF({ send_client: true })
    },
    enviarParaCliente(hash) {
      GlobalBus.$emit(MODAL.SEND_COMUNICATE, {
        clientes: this.clienteAtual,
        noticia: {
          titulo: 'Relatório - Análise Portfólio',
          descricao: 'Relatório .PDF com sua análise de portfólio',
          url: hash + '::simulation',
          tipo: 'pdf',
        },
        hideUrl: true,
        fixComunicado: true,
      })
    },
    openSelectModelPDF({ send_client = false } = {}) {
      const params = {
        corretora: 'Todas',
        // with_current_portfolio_comparison: false,
        // benchmarks_selection: JSON.stringify({
        //   simulation_and_current_portfolio_backtest: this
        //     .benchmarks_selecionados_grafico,
        // }),
      }

      const bench_selection = {}

      if (this.benchmark_graph_changed) {
        bench_selection.simulation_and_current_portfolio_backtest =
          this.benchmarks_selecionados_grafico
      }

      params.benchmarks_selection = JSON.stringify(bench_selection)

      GlobalBus.$emit(MODAL.SELECT_PDF_MODEL, 'simulador.analise', {
        hash: this.simulacao.hash_code,
        id_cliente: this.clienteAtual.id,
        params,
        modo_simulador: this.modo,
        send_client,
      })
    },
  },
}
</script>

<template>
  <section class="container-sm mt-6">
    <ConditionalTeleport
      v-if="!clienteModal"
      to="page-header-actions"
      :routes="moduleRoutes"
    >
      <BasePageHeader>
        <template v-slot:actions>
          <BaseSplitButton
            label="Selecionar outra simulação"
            :items="headerMenuActions"
            @click="openSearchHistory"
            @select="onHeaderAction"
          />
        </template>
      </BasePageHeader>
    </ConditionalTeleport>

    <FeedbackWrapper
      v-if="!clienteAtual.name"
      bordered
      :no-data="true"
      message="Selecione um cliente para simular"
      :min-height="360"
    />
    <div v-else-if="carregando" class="row justify-content-center mt-n3 simulador-analise__skeleton">
      <div class="col-12">
        <div class="az-card-bordered">
          <BaseLoadingSkeleton height="56px" />
        </div>
      </div>
      <div class="col-6">
        <div class="az-card-bordered h-100">
          <BaseLoadingSkeleton height="220px" />
        </div>
      </div>
      <div class="col-6">
        <div class="az-card-bordered h-100">
          <BaseLoadingSkeleton height="220px" />
        </div>
      </div>
      <div class="col-12">
        <div class="az-card-bordered">
          <BaseLoadingSkeleton height="320px" />
        </div>
      </div>
    </div>

    <FeedbackWrapper
      v-else-if="!simulacao.hash_code"
      bordered
      :no-data="true"
      message="Selecione uma simulação"
      :min-height="360"
    >
      <template v-slot:button>
        <BaseButton dark outline @click="openSearchHistory">
          Selecionar simulação
        </BaseButton>
      </template>
    </FeedbackWrapper>
    <div v-else class="row justify-content-center mt-n3">
      <div class="col-12">
        <div class="az-card-bordered d-flex align-center" style="max-width: 100%">
          <v-edit-dialog
            :return-value.sync="simulacao.nome_simulacao"
            large
            cancel-text="Cancelar"
            save-text="Salvar"
            @save="salvarNomeSimulacao"
          >
            <span
              ref="nomeSpan"
              class="az-ds-card-title simulador-analise__nome"
            >
              {{ simulacao.nome_simulacao }}
            </span>

            <template v-slot:input>
              <v-text-field
                v-model="simulacao.nome_simulacao"
                dense
                hide-details
                label="Simulação"
              ></v-text-field>
            </template>
          </v-edit-dialog>
          <v-spacer />
          <BaseSplitButton
            label="Editar nome"
            :items="cardMenuActions"
            @click="openEditNome"
            @select="onCardAction"
          />
        </div>
      </div>
      <div v-if="simulationError" class="col-12">
        <BaseAlert icon="warning" iconColor="warning">
          {{ simulationError }}
          <template v-slot:button>
            <BaseButton
              v-if="restricoes_simulacao.tipo_simulador"
              small
              dark
              outline
              min-width="80px"
              class="mx-10"
              @click="toRestricoes"
            >
              Alterar restrições
            </BaseButton>
          </template>
        </BaseAlert>
      </div>
      <div v-if="alertMessages.length" class="col-12">
        <BaseAlert icon="info" iconColor="info">
          <span v-for="m in alertMessages" :key="m" v-html="m"></span>
        </BaseAlert>
      </div>
      <div class="col-6">
        <div class="az-card-bordered h-100">
          <div class="d-flex align-center mb-10">
            <span class="az-ds-card-title"> Backtest </span>
            <v-spacer />
            <BaseModal
              max-width="80%"
              :destroy-on-close="true"
              height="600px"
              class="d-inline"
            >
              <template v-slot:button>
                <div class="d-flex align-center" @click="abrirModal">
                  <span class="az-text-small az-muted mr-1"> Ampliar </span>
                  <icon-svg name="mdi-fullscreen" color="#8E8E8E" :size="16" />
                </div>
              </template>
              <div>
                <Title title="Backtest simulada" />
                <line-chart
                  ref="rentabilidade2"
                  :chart-data="lineDataSimulacao"
                  :options="lineOptions"
                  :styles="{ height: '80vh', width: '100%' }"
                >
                </line-chart>
              </div>
            </BaseModal>
          </div>
          <line-chart
            ref="rentabilidade"
            :chart-data="lineDataSimulacao"
            :options="lineOptions"
          >
          </line-chart>
          <div class="d-flex">
            <v-spacer />
            <v-menu top offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <div class="d-flex align-center" v-bind="attrs" v-on="on">
                  <span class="az-text-small az-muted mr-2">
                    Visualizar benchmarks:
                  </span>
                  <v-btn fab x-small class="elevation-0" color="primary">
                    <icon-svg name="mdi-plus" color="#FFFFFF" :size="16" />
                  </v-btn>
                </div>
              </template>
              <div
                class="bg-white p-5"
                style="
                  border-radius: 6px;
                  width: 200px;
                  max-height: 320px;
                  overflow-y: auto;
                "
              >
                <v-checkbox
                  v-for="bench in BENCHMARKS"
                  :key="bench.id"
                  v-model="benchmarks_selecionados_grafico"
                  :label="bench.nome"
                  :value="bench.id"
                  color="primary"
                  dense
                  hide-details
                  @change="benchmark_graph_changed = true"
                />
              </div>
            </v-menu>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="az-card-bordered h-100">
          <span class="az-ds-card-title"> Política de investimento simulada </span>
          <div class="mt-10">
            <div class="d-flex align-items-baseline">
              <p class="az-text-primary font-semibold mb-1"> Perfil de Risco </p>
              <v-tooltip right class="ml-2">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <icon-svg
                      name="info-circle"
                      color="secondary"
                      :size="16"
                    />
                  </span>
                </template>
                <div style="max-width: 300px">
                  <span>
                    Para possibilitar a comparação de portfolios com horizontes
                    diferentes, anualizamos as estatísticas dos mesmos, ou seja,
                    passamos o retorno e a volatilidade para um valor anual
                    equivalente.
                  </span>
                </div>
              </v-tooltip>
            </div>
            <v-divider />
            <div class="row">
              <span class="col-8 az-text-secondary az-size-14"> Perfil de Risco </span>
              <span class="col-4 az-text-secondary az-size-14">
                {{ restricoes_simulacao.perfil || 'Desconhecido' }}
              </span>
              <div class="col-12 py-0">
                <v-divider />
              </div>
              <span class="col-8 az-text-secondary az-size-14">
                Retorno Esperado (% CDI anualizado)
              </span>
              <span class="col-4 az-text-secondary az-size-14">
                {{ toPercent(estatisticas.coef_cdi * 100 || 0) }}
              </span>
              <div class="col-12 py-0">
                <v-divider />
              </div>
              <span class="col-8 az-text-secondary az-size-14">
                Volatilidade Esperada (anualizada)
              </span>
              <span class="col-4 az-text-secondary az-size-14">
                {{ toPercent(estatisticas.vol * 100 || 0) }}
              </span>
              <div class="col-12 py-0">
                <v-divider />
              </div>
            </div>
          </div>

          <div style="margin-top: 20px">
            <p class="az-text-primary font-semibold mb-1">Cenários</p>
            <v-divider />
            <v-simple-table class="cenarios">
              <template v-slot>
                <thead>
                  <tr>
                    <th></th>
                    <th
                      class="text-center"
                      colspan="3"
                      style="border-bottom-width: 2px"
                    >
                      Retornos (% CDI anualizado) por cenário
                    </th>
                    <th></th>
                  </tr>
                  <tr>
                    <th></th>
                    <th style="border-left-width: 2px" class="text-center">
                      Pessimista
                    </th>
                    <th class="text-center"> Base</th>
                    <th style="border-right-width: 2px" class="text-center">
                      Otimista
                    </th>
                    <th class="text-center">
                      Vol (%) <br />
                      esperada
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="text-bold">
                    <td style="border-top-width: 2px" class="text-left">
                      {{ toTitleCase(modo) }}
                    </td>
                    <td style="border-top-width: 2px; border-left-width: 2px">
                      {{ cenario_portfolio.pessimistic_scenario }}
                    </td>
                    <td style="border-top-width: 2px">
                      {{ cenario_portfolio.base_scenario }}
                    </td>
                    <td style="border-top-width: 2px; border-right-width: 2px">
                      {{ cenario_portfolio.optimistic_scenario }}
                    </td>
                    <td style="border-top-width: 2px">
                      {{ cenario_portfolio.expected_volatility }}
                    </td>
                  </tr>
                  <tr
                    v-for="c in cenarios"
                    v-if="
                      !['portfolio', 'caixa'].includes(c.classe.toLowerCase())
                    "
                  >
                    <td class="text-left">{{ c.classe }}</td>
                    <td
                      style="border-bottom-width: 2px; border-left-width: 2px"
                    >
                      {{ c.pessimistic_scenario }}
                    </td>
                    <td style="border-bottom-width: 2px">
                      {{ c.base_scenario }}
                    </td>
                    <td
                      style="border-bottom-width: 2px; border-right-width: 2px"
                    >
                      {{ c.optimistic_scenario }}
                    </td>
                    <td> {{ c.expected_volatility }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <span class="az-text-small">
              *Ativos fixados da posição e que não possuem as informações
              completas no consolidador, não são considerados nessa estatística
            </span>
          </div>

          <div style="margin-top: 20px">
            <p class="az-text-primary font-semibold mb-1">Horizonte de Análise</p>
            <v-divider />
            <div class="row">
              <span class="col-8 az-text-secondary az-size-14">
                {{
                  backtest.portfolio ? backtest.portfolio.data[0] || '-' : '-'
                }}
                {{
                  backtest.portfolio && backtest.portfolio.data.length > 0
                    ? ' a ' +
                        backtest.portfolio.data[
                          backtest.portfolio.data.length - 1
                        ] || ''
                    : ''
                }}
              </span>
              <span class="col-4 az-text-secondary az-size-14">{{ horizonteDiff }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div
          class="az-card-bordered print-only print-break-before d-flex justify-content-center h-100"
          style="flex-direction: column"
        >
          <span class="az-ds-card-title d-block mb-10"> Composição estratégica </span>
          <ShowComposition :values="compEstr" :size="0" chartShowMoney center-text />
        </div>
      </div>

      <div class="col-6">
        <div
          class="az-card-bordered print-only print-break-before d-flex flex-column justify-content-center h-100"
        >
          <span class="az-ds-card-title d-block mb-10"> Liquidez portfólio simulado </span>
          <ShowLiquidez v-if="liquidez.length" :values="liquidez" :size="0" />
        </div>
      </div>

      <div class="col-12">
        <div class="az-card-bordered print-only print-break-before">
          <span class="az-ds-card-title d-block mb-10"> Estatística portfólio simulado </span>
          <TabelaRentBenchmark :rentabilidades-all="estatistica_portfolio" />
        </div>
      </div>

      <div class="col-12">
        <div class="az-card-bordered print-only print-break-before">
          <span class="az-ds-card-title d-block mb-10"> Evolução mensal </span>
          <TabelaRetornoMensais :retorno-mensal="retorno_mensal" />
        </div>
      </div>

      <div class="col-12">
        <div class="az-card-bordered">
          <div class="d-flex align-center mb-10">
            <span class="az-ds-card-title"> Carteira simulada </span>
            <v-spacer />
            <div class="text-right">
              <span class="az-text-small az-muted d-block"> P/L: </span>
              <span class="az-text-primary font-semibold"> {{ toMoney(pl_total) }} </span>
            </div>
          </div>
          <SimulatorPortfolioTable
            :headers="headerCarteiraSimulada"
            :items="ativos"
            :group-by="modo"
            :fixed-assets="novosAtivos"
            @save-notes="handleSaveNotes"
            @block-asset="bloquearAtivo"
            @change-asset="trocarAtivo"
            @fix-asset="fixarAtivo"
          />
        </div>
      </div>
      <div class="col-12">
        <div class="az-card-bordered">
          <div class="d-flex align-center mb-10">
            <span class="az-ds-card-title"> Operações </span>
            <v-spacer />
            <div class="text-right">
              <span class="az-text-small az-muted d-block"> Aportes: </span>
              <span class="az-text-primary font-semibold">
                {{
                  sumPL(
                    operacoes.filter((a) => {
                      return a.operacao === 'C'
                    }),
                    'movimentacao'
                  )
                }}
              </span>
            </div>
            <div class="ml-10 text-right">
              <span class="az-text-small az-muted d-block"> Resgates: </span>
              <span class="az-text-primary font-semibold">
                {{
                  sumPL(
                    operacoes.filter((a) => {
                      return a.operacao === 'V'
                    }),
                    'movimentacao'
                  ).replace('-', '')
                }}
              </span>
            </div>
          </div>

          <SimulatorOperationsTable
            :headers="headerCarteiraCompleta"
            :items="operacoes"
            :group-by="modo"
            :fixed-assets="novosAtivos"
            @save-notes="handleSaveNotes"
            @fix-asset="fixarAtivo"
          />
        </div>
      </div>

      <v-scale-transition>
        <ButtonAction v-if="!simulando" color="white">
          <div
            v-if="simulacao.simulacao_salva || simulacao.expire_date"
            class="d-flex align-center"
          >
            <v-btn
              color="white"
              tile
              style="height: 70px !important"
              width="200"
              depressed
              @click="toPermanent"
            >
              <icon-svg name="mdi-clock" color="primary" class="mr-3" />
              <div class="d-flex flex-column align-start">
                <div v-if="!simulacao.simulacao_salva">
                  <span class="az-text-small">
                    Simulação será apagada <br />
                    {{ getDistanceDate(simulacao.expire_date) }}
                  </span>
                  <br />
                  <p class="text-primary mb-0"> Tornar permanente </p>
                </div>
                <div v-else>
                  <span class="az-text-small"> Simulação permanente </span>
                </div>
              </div>
            </v-btn>
            <div class="d-flex align-center mx-2">
              <div style="border-right: 1px solid rgba(0, 0, 0, 0.12); height: 40px"></div>
            </div>
          </div>
          <v-btn
            v-if="!has_changes"
            color="white"
            tile
            style="height: 70px !important"
            depressed
            :loading="loadingPDF"
            @click="openSelectModelPDF"
          >
            <div class="d-flex flex-column align-center">
              <icon-svg name="mdi-file-pdf-box" size="18" color="black" />
              <span class="text-sm mt-1">Exportar</span>
            </div>
          </v-btn>
          <v-btn
            v-if="!has_changes"
            hidden
            color="white"
            tile
            style="height: 70px !important"
            depressed
            :loading="loadingCliente"
            @click="sendClient"
          >
            <div class="d-flex flex-column align-center">
              <icon-svg name="mdi-send" size="18" color="black" />
              <span class="text-sm mt-1">Mobile</span>
            </div>
          </v-btn>
          <v-btn
            v-if="SHOW_WORKSPACE"
            color="white"
            tile
            depressed
            style="height: 70px !important"
            @click="openSendComponent"
          >
            <div class="d-flex flex-column align-center">
              <icon-svg name="mdi-share-variant" size="18" color="black" />
              <span class="text-sm mt-1">Workspace</span>
            </div>
          </v-btn>
          <v-btn
            v-if="restricoes_simulacao.tipo_simulador"
            color="white"
            tile
            style="height: 70px !important"
            depressed
            @click="toRestricoes"
          >
            <div class="d-flex flex-column align-center">
              <icon-svg name="mdi-pencil" size="18" color="black" />
              <span class="text-sm mt-1">Alterar</span>
            </div>
          </v-btn>
          <v-btn
            v-if="has_changes"
            color="white"
            tile
            style="height: 70px !important"
            depressed
            @click="simulateAgain"
          >
            <div class="d-flex flex-column align-center">
              <icon-svg name="mdi-play-circle-outline" size="18" color="black" />
              <span class="text-sm mt-1">Simular</span>
            </div>
          </v-btn>
        </ButtonAction>
      </v-scale-transition>

      <v-scale-transition>
        <div
          v-if="simulando"
          class="v-application"
          style="
            position: fixed;
            bottom: 0;
            width: 40%;
            margin: auto;
            margin-bottom: 20px;
            z-index: 3;
            left: 0;
            right: 0;
          "
        >
          <LoadingStatus
            :loading="simulando"
            :load="simulacao.load"
            :status="simulacao.status"
          />
        </div>
      </v-scale-transition>
    </div>
    <ModalPortfolioReviewEditNotes />
    <ModalPesquisaHistorico :bus="busModal" />
    <!-- ...ativos, -> Considerar que os ativos da simulacao nao podem ser fixados -->
    <ModalTrocar
      :bus="busModal"
      :fixados="[...novosAtivos]"
      :pl-total="pl_total"
    />
    <ModalRestricoes />
    <ModalAmpliarTabela />
  </section>
</template>

<style lang="sass" scope>
.simulador-analise__nome
  cursor: pointer
  transition: opacity 0.15s ease

  &:hover
    opacity: 0.7

.cenarios
  background-color: transparent !important

  table
    td, th
      font-size: 12px !important
      color: var(--dark) !important
      padding: 0px
      border: 0px solid var(--primary)
      text-align: center
      height: 30px

.table-responsive-sm
  min-width: 60%

.tabela-ativos table
  .v-row-group__header
    background-color: transparent !important

  td
    border-bottom-width: 0px !important

  th
    font-size: 10px !important
    padding-bottom: 00px !important
    height: 30px !important

  td:not(:last-child):not(:first-child), th:not(:last-child):not(:first-child)
    border-left: 1px dashed var(--gray-3)

  .v-row-group__header .text-bold
    color: var(--dark)
    font-size: 1rem
    font-weight: 600 !important
</style>
